module.exports = __webpack_public_path__ + "static/media/blande.d4f0fa62.m4a";